import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { eventsQueryKeys } from 'features/events';
import { TransectionApiServices } from 'features/transaction_list/api/transection-api.service';
import { queryClient } from 'providers';

const { updateItemsStatus } = TransectionApiServices();

export const useUpdateItemsStatus = () => {
    const { message } = App.useApp();

    return useMutation(
        (payload: any) => {
            return updateItemsStatus(payload);
        },
        {
            onError: (error) => {
                const uiMessage = handleError(error);

                message.error(uiMessage);
            },
            onSuccess: (response: any) => {
                queryClient.invalidateQueries({
                    queryKey: eventsQueryKeys.all,
                });
                if (response.ResponseStatus === 1) {
                    message.success(response.ResponseMessage || "Status has been updated successfully!!");
                } else {
                    message.error(response.ResponseMessage || "An error occurred while updating the item status.");
                }
            },
        },
    );
};